export const COOKIE_SESSION = 'session';
export const COOKIE_REFRESH_TOKEN = 'refresh_token';
export const COOKIE_OAUTH_STATE = 'oauth_state';

export const DEFAULT_CALLBACK_PATH = '/api/auth/callback';
export const DEFAULT_SCOPES = [
  'company',
  'openid',
  'profile',
  'email',
] as const;

export const DEFAULT_SESSION_MAX_AGE = 60 * 60 * 24 * 7; // 7 days
export const DEFAULT_REFRESH_MAX_AGE = 60 * 60 * 24 * 30; // 30 days
export const DEFAULT_STATE_MAX_AGE = 60 * 10; // 10 minutes
export const DEFAULT_EXPIRY_BUFFER_SEC = 60;

export const DEFAULT_ROUTES = {
  login: '/api/auth/login',
  callback: '/api/auth/callback',
  me: '/api/auth/me',
  jwt: '/api/auth/jwt',
  refresh: '/api/auth/refresh',
  logout: '/api/auth/logout',
} as const;

export const DEFAULT_ERROR_REDIRECT = '/?error=';
